<template>
  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col col-lg-9 col-xl-8">
        <div class="row">
          <div class="col">
            <h1 v-if="complete.title" class="text-center">{{ complete.title }}</h1>
            <h4 v-if="complete.body" class="text-center body p-5" v-html="complete.body"></h4>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col col-sm-3" v-for="response in complete.responses" :key="response.value">
            <button type="button" class="btn btn-block text-capitalize" @click="$emit('response', response.value)">
              {{ response.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    complete: {
      body: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.body {
  @extend .p-3;
  @extend .mb-4;
  @extend .border;
  @extend .bg-white;

  max-height: 500px;
  overflow-y: auto;
}
</style>
